// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__ciyIa","brightness":"Banner_brightness__wzZBn","border":"Banner_border__Ez2Jz","scale":"Banner_scale__50BgK"};